import React from "react";

let Loading = require("./loading");
let SuspendedSlat = require("./moderation-suspended-slat");

class moderationSaveForLaterSlats extends React.Component {
    render() {
        let uploadArray = [];

        if (this.props.batch.uploads.length > 0) {
            this.props.batch.uploads.forEach(upload => {
                uploadArray.push(
                    <SuspendedSlat key={upload.id} upload={upload} />
                );
            });
        } else {
            if (
                this.props.batch.result === "SEARCH_SUSPENDED_UPLOADS_SUCCESS"
            ) {
                return <div className="no-results"><h3>No Results</h3></div>;
            } else {
                if (
                    this.props.batch.result ===
                    "FETCH_SUSPENDED_UPLOADS_SUCCESS"
                ) {
                    return (
                        <div className="no-results">
                            There aren't any suspended uploads to review at the moment.
                        </div>
                    );
                } else {
                    return <Loading />;
                }
            }
        }

        return (
            <section className="save-for-later-slats">
                {uploadArray}
            </section>
        );
    }
}

module.exports = moderationSaveForLaterSlats;
